import React from 'react';
import { createComponent } from '@lit/react';
import { IxPrimaryTab as LitComp } from '../IxPrimaryTab.js';

customElements.define('ix-primary-tab', LitComp);

export const IxPrimaryTab = createComponent({
  tagName: 'ix-primary-tab-react',
  elementClass: LitComp,
  react: React,
});
